import { useQuery } from '@apollo/client';
import { GetSharedFolders } from 'gql/patients/__generated__/GetSharedFolders';
import { GET_SHARED_FOLDERS } from 'gql/patients/queries';
import { FC, useMemo } from 'react';
import { List } from 'antd';
import { StyledListItemContent } from 'theme/styled';
import { useSearchParams } from 'react-router-dom';

import FolderItem from './FolderItem';
import { Loading } from 'components/ui';
import FolderContent from './FolderContent';

// import FileItem from './FileItem';

interface IProps {
  id: string;
  setTotal(total: number): void;
}

const Folders: FC<IProps> = ({ id, setTotal }) => {
  const [searchParams] = useSearchParams();
  const { data, loading } = useQuery<GetSharedFolders>(GET_SHARED_FOLDERS, {
    variables: {
      query: {
        patient_id: id
      }
    },
    onCompleted(data) {
      setTotal(data.getSharedFolders.data.length || 0);
    }
  });

  const folderId = useMemo(() => {
    const pageQuery = searchParams.get('page');
    const parts = pageQuery?.split('/') || [];
    const page = parts[parts.length - 1];

    if (!page || page === 'shared_folders') {
      return null;
    }

    return page;
  }, [searchParams]);

  const folders = data?.getSharedFolders.data || [];

  if (loading) {
    return <Loading />;
  }

  if (folderId) {
    return <FolderContent patientId={id} folderId={folderId} />;
  }

  return (
    <StyledListItemContent>
      <List
        dataSource={folders}
        renderItem={item => (
          <List.Item className="list-content-item">
            <FolderItem
              key={`folder-${item.id}`}
              id={item.id}
              name={item.name}
            />
          </List.Item>
        )}
      />
    </StyledListItemContent>
  );
};

export default Folders;
